(() => {
  const selectedCards = panel => [...panel.querySelectorAll('[data-jewel-id]')].filter(card => {
    const input = card.querySelector('[data-jewel-select]');
    return !input || (input.checked && !input.disabled);
  });
  function selection(panel) {
    const cards = selectedCards(panel);
    const complete = cards.length === panel.querySelectorAll('[data-jewel-id]').length;
    const total = cards.reduce((sum,card)=>sum+Number(card.dataset.jewelPrice),0);
    const discount = complete && Number(panel.dataset.discountPercent) === 10 ? Math.floor(total / 10) : 0;
    const priced = cards.length > 0 && cards.every(c=>Number(c.dataset.jewelPrice)>0);
    const available = priced && cards.every(c=>c.dataset.jewelAvailable==='true');
    const params = new URLSearchParams(panel.dataset.hash.replace(/^#/, ''));
    if (!complete) {
      const keys={lobe1:'l1',lobe2:'l2',lobe3:'l3',conch:'ch',helix:'hx',helix2:'h2',tragus:'ts',flat:'ft',rook:'rk',daith:'dh',anti_helix:'ax',snug:'sg',anti_tragus:'as'};
      [...panel.querySelectorAll('[data-jewel-id]')].filter(c=>!cards.includes(c)).forEach(c=>{
        const key=c.dataset.placementKey,chain=key?.endsWith('_chain'),base=chain?key.slice(0,-6):key;
        params.delete(key);params.delete((keys[base]||base)+(chain?'c':''));
      });
    }
    return {cards,complete,total,discount,priced,available,hash:'#'+params.toString(),
      restock:cards.some(c=>c.querySelector('[data-delivery-state="restock"]')),
      ready:cards.some(c=>c.querySelector('[data-delivery-state="ready"]'))};
  }
  function catalogPresentation(group,catalog) {
    const properties=group.items[0]?.properties || {};
    if (!String(group.key).startsWith('catalog-') || group.items.some(item=>item.properties?._OverlayImg)) return {};
    const sourceId=properties._CompositionSourceVariant || properties._CompositionVariant;
    let candidates=catalog.filter(photo=>group.items.every(item=>photo.ids.some(id=>String(id)===String(item.variant_id))) &&
      (sourceId ? String(photo.variantId)===String(sourceId) : photo.title===group.title && photo.material===properties._CompositionMaterial));
    if (properties._CompositionReferenceImage) candidates=candidates.filter(photo=>photo.image===properties._CompositionReferenceImage);
    const identities=new Set(candidates.map(photo=>String(photo.variantId)+'|'+photo.ids.map(String).sort().join(',')));
    if (!candidates.length || identities.size!==1) return {};
    const photo=candidates[0],remaining=[...group.items];
    return {displayImage:photo.image,displayItems:photo.items.map((jewel,index)=>{
      const at=remaining.findIndex(item=>String(item.variant_id)===String(jewel.id));
      if (at!==-1) return remaining.splice(at,1)[0];
      return {key:'omitted-'+index,product_title:jewel.title,image:jewel.image,properties:{},excluded:true,soldOut:jewel.soldOut};
    })};
  }
  function deliveryGroups(groups,metadata) {
    const buckets = Object.fromEntries(['ready','restock','unavailable','checking'].map(state=>[state,{state,groups:[]}]));
    for(const group of groups) {
      const items = group.isComposition ? group.items : [group.item];
      const byState = new Map();
      for(const item of items) {
        const data = metadata[item.key];
        const state = data && data.quantity === item.quantity && String(data.variantId)===String(item.variant_id) && buckets[data.state] ? data.state : 'checking';
        if(!byState.has(state)) byState.set(state,[]);
        byState.get(state).push(item);
      }
      let allocated=0,part=0;
      for(const [state,items] of byState) {
        if(!group.isComposition) {buckets[state].groups.push(group);continue;}
        const originalTotalPrice=items.reduce((sum,item)=>sum+item.original_price*item.quantity,0);
        const totalPrice=++part===byState.size ? group.totalPrice-allocated
          : group.originalTotalPrice ? Math.floor(group.totalPrice*originalTotalPrice/group.originalTotalPrice) : 0;
        allocated+=totalPrice;
        const displayItems=group.displayItems?.filter(item=>item.excluded ? part===1 : items.some(included=>included.key===item.key));
        buckets[state].groups.push({...group,items,displayItems,originalTotalPrice,totalPrice,sourceGroup:group});
      }
    }
    return Object.values(buckets).filter(b=>b.groups.length);
  }
  function capacity(variant) {
    if (!variant?.available) return 0;
    const policy=variant.delivery_policy;
    if (policy?.nancy_managed && policy.state === 'restock') return policy.order_limit === null ? Infinity : Math.max(0,Number(policy.order_limit)||0);
    return variant.inventory_quantity === undefined ? 999 : Math.max(0,variant.inventory_quantity);
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('[name="checkout"]');
    if (!button || !document.querySelector('cart-items [data-delivery-state="restock"],cart-drawer [data-delivery-state="restock"]')) return;
    event.preventDefault();
    if (window.SolsticeCartAppMounted) document.dispatchEvent(new CustomEvent('open-ear-cart'));
    else {
      let message=button.parentElement.querySelector('[data-restock-checkout-error]');
      if(!message){message=document.createElement('p');message.dataset.restockCheckoutError='';message.setAttribute('role','alert');button.after(message);}
      message.textContent=button.dataset.restockError || document.querySelector('[data-restock-error]')?.dataset.restockError || 'Please reload the page to check delivery times.';
    }
  },true);
  window.SolsticeRestock={selectedCards,selection,catalogPresentation,deliveryGroups,capacity};
})();
